import { UserStatus } from "app/users/models/UserStatus";

export class ProductInfo {
  constructor(public productName) { }

  editUserUrl: string;
  collapsed = false;
  userStatus: UserStatus;
  display = false;
  loading = false;
}
